module.exports = __webpack_public_path__ + "static/media/orders_hover.4dbd580d.svg";